import { SSOAuthConfig } from '../signUpSlice';
import { RegisterUserRequestBody, SignupFormData } from '../types';

export const makeCaregiverObject = (formData: SignupFormData) => ({
  first_name: formData.caregiverFirstName ?? '',
  last_name: formData.caregiverLastName ?? '',
  dob: formData.caregiverDateOfBirth ?? '',
  state: formData.caregiverStateOfResidence ?? '',
  relationship: formData.caregiverRelationshipToMember ?? '',
  phone_number: formData.caregiverPhoneNumber ?? '',
});

export const hasCaregiver = (formData: SignupFormData): boolean => {
  const caregiver = makeCaregiverObject(formData);
  return Object.values(caregiver).some(Boolean);
};

export const makeRegisterUserRequestBody = (
  formData: SignupFormData,
  privacyPolicyEffectiveDate: string,
  eulaPolicyEffectiveDate: string,
  wellframeUserId?: number,
  ssoAuthConfig?: SSOAuthConfig,
): RegisterUserRequestBody => {
  const caregiver = makeCaregiverObject(formData);
  const userHasCaregiver = hasCaregiver(formData);

  return {
    program_user: {
      id: wellframeUserId,
      member_id: formData.memberId,
      status: 'registered',
      code: formData.accessCode,
      user_type: 'regular',
      first_name: formData.memberFirstName,
      last_name: formData.memberLastName,
      dob: formData.memberDateOfBirth,
      gender: formData.memberGender,
      state: formData.memberStateOfResidence,
      phone_number: formData.memberPhoneNumber,
      email: formData.memberEmail || formData?.memberProfileEmail || '',
      password: formData.password,
      privacy_policy: { effective_date: privacyPolicyEffectiveDate },
      eula_policy: { effective_date: eulaPolicyEffectiveDate },
      caregiver: userHasCaregiver ? caregiver : undefined,
    },
    auth: ssoAuthConfig && {
      integration_id: ssoAuthConfig.integrationId,
      auth_user_id: ssoAuthConfig.authUserId,
    },
  };
};
